<template>
  <div>
    <v-card>
      <div class="pa-6">
        <v-card outlined>
          <v-data-table
            item-key="id"
            :headers="headers"
            :loading="loading"
            :items="students"
            :items-per-page="pagination.itemsPerPage"
            :page.sync="pagination.page"
            :server-items-length="pagination.totalItems"
            :disable-sort="$vuetify.breakpoint.smAndDown"
            :footer-props="{ 'items-per-page-text': 'Số học sinh mỗi trang' }"
            :height="400"
            v-bind="this.$attrs"
            fixed-header
            @pagination="updatePagination"
          >
            <template v-slot:[`footer.page-text`]="items">
              Giám thị thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} giám thị
            </template>
            <template v-slot:[`item.rooms`]="{ item }">
              {{ formatArray(item.rooms) }}
            </template>
            <template v-slot:[`item.subjects`]="{ item }">
              {{ formatArray(item.subjects) }}
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

const originHeaders = [
  {
    text: 'Giáo viên',
    value: 'teacher.name',
    align: 'left',
    sortable: false,
    width: '20%'
  },
  {
    text: 'Phòng thi',
    value: 'rooms',
    align: 'left',
    sortable: false,
    width: '40%'
  },
  {
    text: 'Môn thi',
    value: 'subjects',
    align: 'left',
    sortable: false,
    show: true,
    width: '40%'
  }
]

export default {
  props: {
    query: Object,
    subjects: Array,
    rooms: Array,
    type: String,
    grade: String
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      dialog: false,
      updateDialog: false,
      deleteDialog: false,
      confirmDialog: false,
      showColumnSelector: false,
      students: [],
      item: {},
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0
      }
    }
  },
  computed: {},
  methods: {
    ...mapActions('monitor', ['fetchMonitorExams', 'countMonitorExams']),
    async refresh() {
      this.$loading.active = true
      this.loading = true
      const start = (this.pagination.page - 1) * this.pagination.itemsPerPage
      const limit = this.pagination.itemsPerPage
      try {
        this.pagination.totalItems = await this.countMonitorExams(this.query)
        this.students = await this.fetchMonitorExams({
          _start: start,
          _limit: limit,
          ...this.query
        })
      } catch (error) {
        this.$alert.error('Lỗi load thông tin giám thị')
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },
    formatArray(array) {
      const names = array.map(item => item.name)
      return names.join(', ')
    },
    updatePagination(val) {
      this.pagination.page = val.page
      this.pagination.itemsPerPage = val.itemsPerPage
    },
    update(item) {
      this.item = item
      this.updateDialog = true
    },
    remove(item) {
      this.item = item
      this.deleteDialog = true
    },
    openCreate() {
      this.dialog = true
    },
    openConfirm() {
      this.confirmDialog = true
    },
    close() {
      this.dialog = false
    },
    closeUpdate() {
      this.refresh()
      this.updateDialog = false
    },
    closeDelete() {
      this.deleteDialog = false
    },
    closeConfirm() {
      this.confirmDialog = false
    }
  },
  watch: {
    'pagination.page'() {
      this.refresh()
    },
    'pagination.itemsPerPage'() {
      this.refresh()
    },
    query: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refresh()
        }
      }
    }
  },
  filters: {
    getStatus: item => {
      if (item.status === 'seated') {
        return 'Đã xếp'
      } else if (item.status === 'notSeated') {
        return 'Chưa xếp'
      } else if (item.status === 'seating') {
        return 'Đang xếp'
      } else {
        return '-'
      }
    }
  },
  components: {}
}
</script>
